import cmd from '../../common/Command'

class SearchModel {
  constructor () {
    this.keyword = ''
  }
}

export default SearchModel



// WEBPACK FOOTER //
// ./src/store/model/SearchModel.js